/**
 * Ayuda: guías cortas para grabar en cada modo y resolver los problemas más
 * comunes sin escribirnos. Pública (se puede enlazar desde correos y la tienda).
 */
import { Link } from 'react-router'
import { useApp } from '../components/AppContext'
import { Brand } from '../components/ui'
import { useDocumentTitle } from '../lib/hooks'

export function Help() {
  useDocumentTitle('Ayuda')
  const { session } = useApp()
  return (
    <div className="public">
      <div className="public-head">
        <Brand to={session ? '/' : '/login'} />
        <Link to={session ? '/' : '/login'} className="btn sm">
          {session ? 'Ir a eco' : 'Entrar'}
        </Link>
      </div>
      <div className="page prose">
        <h1>Ayuda</h1>
        <p className="muted">
          Lo más consultado. Si no encuentras la respuesta, escríbenos a{' '}
          <a href="mailto:hola@holaeco.cl">hola@holaeco.cl</a>: respondemos en un día hábil.
        </p>

        <h2 id="grabar">Cómo grabar</h2>
        <h3>En el navegador (Meet, Teams o Zoom web)</h3>
        <ol>
          <li>Entra a la reunión en Chrome o Edge.</li>
          <li>
            Pulsa el ícono de eco en la barra (o <kbd>Alt+Shift+R</kbd>, o clic derecho → «Grabar
            esta reunión con eco»).
          </li>
          <li>Confirma que avisaste a los participantes y pulsa Grabar.</li>
        </ol>
        <p>
          Sigues escuchando la reunión con normalidad. Para detener, vuelve a pulsar el ícono o el
          mismo atajo.
        </p>
        <h3>En una app de escritorio (Zoom o Teams instalados)</h3>
        <ol>
          <li>En el ícono de eco elige «App de escritorio» y pulsa Grabar.</li>
          <li>
            En la ventana de eco, elige la <strong>pantalla completa</strong> y marca{' '}
            <strong>«Compartir audio del sistema»</strong>. eco no guarda la imagen.
          </li>
        </ol>
        <p>
          Funciona en Windows. En macOS el navegador no puede captar el audio de otras apps: usa la
          reunión en el navegador.
        </p>
        <h3>Presencial</h3>
        <p>
          Elige «Presencial»: solo se graba el micrófono. Sirve para una sala de reuniones o una
          entrevista cara a cara. También puedes <Link to="/import">subir un audio</Link> que ya
          tengas.
        </p>

        <h2 id="problemas">Si algo no funciona</h2>
        <h3>«No se pudo abrir el micrófono»</h3>
        <p>
          Permite el micrófono para eco: el ícono de cámara/micrófono en la barra de direcciones o
          Ajustes del navegador → Privacidad → Micrófono. En macOS, además: Ajustes del sistema →
          Privacidad y seguridad → Micrófono → activa Chrome o Edge.
        </p>
        <h3>No se escucha a los demás en la transcripción</h3>
        <p>
          En el navegador, graba desde la pestaña de la reunión (no desde otra). En una app de
          escritorio, revisa que hayas marcado «Compartir audio del sistema».
        </p>
        <h3>Aparece «tu micrófono captó mucho del audio de la reunión»</h3>
        <p>
          Pasa cuando se usan parlantes: tu micrófono también graba a los demás. Con audífonos la
          transcripción separa mejor quién habló.
        </p>
        <h3>Se cortó la conexión o cerré el navegador</h3>
        <p>
          No se pierde nada: los trozos quedan guardados en tu computador y se suben solos cuando
          vuelve la conexión o abres el navegador otra vez.
        </p>
        <h3>La grabación se detuvo sola</h3>
        <p>
          Cuando sales de la llamada, eco te avisa y detiene la grabación a los 3 minutos para no
          gastar tus horas en silencio. Si la reunión sigue, pulsa «Seguir grabando» en el aviso o
          vuelve a la llamada. Además, cada grabación dura como máximo 8 horas.
        </p>
        <h3>Se desconectó el micrófono</h3>
        <p>
          Vuelve a conectarlo: eco lo retoma solo y te avisa. En una reunión online, mientras tanto
          se sigue grabando a los demás.
        </p>
        <h3>Nombres propios mal escritos</h3>
        <p>
          En Ajustes → Vocabulario agrega los nombres de tu equipo, clientes y siglas. Se usan desde
          la próxima reunión.
        </p>

        <h2 id="notas">Notas, preguntas y tareas</h2>
        <ul>
          <li>
            Cada decisión y tarea tiene la cita y el momento en que se dijo: un clic y vas a la
            frase.
          </li>
          <li>
            «Pregunta sobre esta reunión» o «Pregunta a tus reuniones» responde solo con lo que se
            dijo, citando la fuente. Las preguntas no se guardan.
          </li>
          <li>
            En Ajustes → Plantillas propias defines tus secciones; se eligen en cada reunión con «+
            Otra plantilla».
          </li>
          <li>
            <Link to="/tareas">Tareas</Link> junta lo pendiente de todas tus reuniones.
          </li>
        </ul>

        <h2 id="integraciones">Conectar con Zapier, Make o n8n</h2>
        <ol>
          <li>En Zapier crea un Zap con el disparador «Webhooks by Zapier → Catch Hook».</li>
          <li>Copia la URL que te da y pégala en eco: Ajustes → Integraciones.</li>
          <li>Pulsa «Enviar prueba» y termina el Zap con el destino que quieras.</li>
        </ol>
        <p>
          Disponible desde el plan Personal. Cada envío va firmado con la cabecera eco-signature.
        </p>

        <h2 id="audio">¿Qué pasa con mi audio?</h2>
        <p>
          Se transcribe y se borra de nuestros servidores; en cada reunión ves la fecha del borrado.
          Si quieres conservarlo, la extensión guarda una copia en tu carpeta de Descargas. Más
          detalle en <Link to="/seguridad">Seguridad y privacidad</Link>.
        </p>
      </div>
    </div>
  )
}
